module.exports = __webpack_public_path__ + "common/sidebar/icon-calendar-dec774b52de83ddd76094934f7b33f36.svg";